module.exports = __webpack_public_path__ + "img/icon-account-personal-data@3x.9f61f9a4.png";